export default [{
  path: '/importacoes-sped',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Importações Sped',
      path: '',
      component: () => import('@/views/importacoesSped/Index.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        breadcrumb: [
          { name: 'Dados', path: '/dados' },
          { name: 'Importações Sped' }
        ]
      }
    },
    {
      name: 'Importações Sped Adicionar',
      path: 'add',
      component: () => import('@/views/importacoesSped/Add.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        breadcrumb: [
          { name: 'Dados', path: '/dados'},
          { name: 'Importações Sped', path: '/importacoes-sped/' },
          { name: 'Adicionar' }
        ]
      }
    },
    {
      name: 'Importações Sped Editar',
      path: 'edit/:id',
      component: () => import('@/views/importacoesSped/Add.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        breadcrumb: [
          { name: 'Dados', path: '/dados'},
          { name: 'Importações Sped', path: '/importacoes-sped/' },
          { name: 'Editar' }
        ]
      }
    }

  ]
}]  